import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import ReporContext from "../Context/ReportContext";
import './Inputs.css';

export function CurrencyInput({ name, decimalScale = 2, ...rest }) {
    const { setValue, getValues } = useFormContext();
    const { currency } = useContext(ReporContext);

    const value = getValues(name) || 0;

    return (
        <div className="currency__input-wrapper">
            <span>{currency}</span>
            <input
                key={value}
                inputMode="decimal"
                pattern="[0-9.]*"
                onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                }}
                defaultValue={value.toFixed(decimalScale)}
                style={{ minWidth: "100px" }}
                onBlur={(e) => {
                    const newValue = parseFloat(e.target.value) || 0;
                    setValue(name, newValue);
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.target.blur();
                    }
                }}
                {...rest}
            />
        </div>
    );
}

export const CurrencyDisplay = ({ value, decimalScale = 2 }) => {
    const { currency } = useContext(ReporContext);
    const formattedValue = parseFloat(value).toFixed(decimalScale) || "";
    const stringValue = isNaN(formattedValue) || formattedValue === "Infinity" ? "--" : formattedValue;

    return (
        <div className="display__wrapper">
            <span>{currency}</span>
            <span className="display__wrapper-value text-right">{stringValue}</span>
        </div>
    )
};

export function KgInput({ name, ...rest }) {
    const { getValues, setValue } = useFormContext();

    const value = getValues(name) || 0;

    return (
        <div className="kg__input-wrapper">
            <span>Kg</span>
            <input
                key={value}
                inputMode="decimal"
                pattern="[+\-]?[0-9]*\.?[0-9]+"
                onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.-]/g, "");
                }}
                defaultValue={value.toFixed(2)}
                style={{ minWidth: "100px" }}
                onBlur={(e) => {
                    const newValue = parseFloat(e.target.value) || 0;
                    setValue(name, newValue);
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.target.blur();
                    }
                }}
                {...rest}
            />

        </div>
    );
}

export const KgDisplay = ({ value }) => {
    const formattedValue = parseFloat(value).toFixed(2) || "";
    const stringValue = isNaN(formattedValue) || formattedValue === "Infinity" ? "--" : formattedValue;

    return (
        <div className="display__wrapper">
            <span className="display__wrapper-value">{stringValue}</span>
            <span>Kg</span>
        </div>
    )
};

// Componente para campos que deben ser negativos
export const NegativeKgInput = ({ name, ...props }) => {
    const { getValues, setValue } = useFormContext();
    const value = getValues(name) || 0;

    const handleBlur = (e) => {
        let inputValue = parseFloat(e.target.value) || 0;
        // Forzar que sea negativo
        if (inputValue > 0) {
            inputValue = -inputValue;
        }
        setValue(name, inputValue);
        // Actualizar visualmente el input
        e.target.value = inputValue.toFixed(2);
    };

    return (
        <div className="kg__input-wrapper">
            <span>Kg</span>
            <input
                key={value}
                inputMode="decimal"
                pattern="[+\-]?[0-9]*\.?[0-9]+"
                onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.\-]/g, "");
                }}
                defaultValue={value.toFixed(2)}
                style={{ minWidth: "100px" }}
                onBlur={handleBlur}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.target.blur();
                    }
                }}
                {...props}
            />
        </div>
    );
};

export const NegativeCurrencyInput = ({ name, decimalScale = 2, ...props }) => {
    const { getValues, setValue } = useFormContext();
    const { currency } = useContext(ReporContext);
    const value = getValues(name) || 0;

    const handleBlur = (e) => {
        let inputValue = parseFloat(e.target.value) || 0;
        // Forzar que sea negativo
        if (inputValue > 0) {
            inputValue = -inputValue;
        }
        setValue(name, inputValue);
        // Actualizar visualmente el input
        e.target.value = inputValue.toFixed(decimalScale);
    };

    return (
        <div className="currency__input-wrapper">
            <span>{currency}</span>
            <input
                key={value}
                inputMode="decimal"
                pattern="[+\-]?[0-9]*\.?[0-9]+"
                onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.\-]/g, "");
                }}
                defaultValue={value.toFixed(decimalScale)}
                style={{ minWidth: "100px" }}
                onBlur={handleBlur}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.target.blur();
                    }
                }}
                {...props}
            />
        </div>
    );
};
